<template>
  <v-container class="admin-dashboard" fluid>
    <v-row class="flex-grow-0">
      <v-col>
        <v-btn @click="checkInModalShown = true"
               block>{{ $t('admin_acc_gym_checkin.title') }}
        </v-btn>

        <GymCheckInModal :shown="checkInModalShown"
                         @cancel="checkInModalShown = false"></GymCheckInModal>
      </v-col>
      <v-col>
        <v-btn @click="startFacilityCheckIn"
               block>{{ $t('admin_acc_booking.check_in_title') }}
        </v-btn>

        <EditMemberModal :shown="editMemberModalShown"
                         :account-id="editingMemberId"
                         @cancel="onEditMemberModalFinish"
                         @finish="onEditMemberModalFinish"
                         :show-tab="4"></EditMemberModal>
      </v-col>
      <v-col>
        <v-btn @click="scanToCheckOut"
               block>{{ $t('admin_acc_white_card.check_out_title') }}
        </v-btn>

        <WhiteCardActiveRecordModal :shown="checkOutModalShown"
                                    :record="checkingOutRecord"
                                    @cancel="checkOutModalShown = false"></WhiteCardActiveRecordModal>

        <!--        <CheckOutModal :shown="checkOutModalShown"-->
        <!--                       @cancel="checkOutModalShown = false"></CheckOutModal>-->
      </v-col>
    </v-row>
    <v-row class="flex-grow-0">
      <v-col class="py-0">
        <DateInput v-model="dashboardDate"
                   hide-details></DateInput>
      </v-col>
      <v-col>
        <v-select outlined
                  v-model="selectedFilter"
                  :items="filterOptions"
                  hide-details></v-select>
      </v-col>
    </v-row>
    <div class="flex-grow-1 d-flex">
      <v-calendar type="category"
                  :start="calendarDate"
                  :events="processedSessions"
                  :event-color="getSessionColor"
                  :first-interval="firstInterval"
                  :interval-count="intervalCount"
                  :interval-height="24"
                  :categories="categories"
                  category-show-all
                  @mouseup:event="sessionClicked"
                  @mousedown:event="onSessionMouseDown"
                  @mousedown:time-category="timeClicked"
                  @mousemove:time-category="mouseMove"
                  @mouseup:time-category="endDrag"
                  @mouseleave.native="endDrag"
                  class="admin-dashboard-calendar">
        <template v-slot:category="{category}">
          <v-container class="text-center fixed-categories">
            {{ itemMap[category].name }}
            <!--                    <v-icon>fas fa-info</v-icon>-->
          </v-container>
        </template>
        <!--        <template v-slot:category="{category}">-->
        <!--          <label style="width: 100%; text-align: center;">{{ itemMap[category].name }}</label>-->
        <!--        </template>-->
        <template v-slot:event="{event}">
          <v-menu v-if="event.admin_booking"
                  open-on-hover
                  offset-x>
            <template #activator="{on, attrs}">
              <div class="create-event"
                   v-on="on"
                   v-bind="attrs"
                   @mousedown.stop="startDrag(event)">
                <div class="create-event-drag-bottom"
                     @mousedown.stop="extendBottom(event)">
                  <v-icon x-small>mdi-menu</v-icon>
                </div>
              </div>
            </template>
            <v-list dense>
              <v-list-item dense
                           @click="createBooking(event)">
                <v-list-item-title>{{ $t('admin_acc_booking_add.title') }}</v-list-item-title>
              </v-list-item>
              <v-list-item dense
                           @click="cancelCreate">
                <v-list-item-title>{{ $t('cancel') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-calendar>
      <div class="dashboard-calendar-legends">
        <div class="d-flex justify-space-between">
          <div class="dashboard-calendar-legend available"></div>
          {{ $t('booking_status.available') }}
        </div>
        <div class="d-flex justify-space-between">
          <div class="dashboard-calendar-legend excluded"></div>
          {{ $t('booking_status.excluded') }}
        </div>
        <div class="d-flex justify-space-between">
          <div class="dashboard-calendar-legend checked-in"></div>
          {{ $t('booking_status.checked_in') }}
        </div>
        <div class="d-flex justify-space-between">
          <div class="dashboard-calendar-legend not-checked-in"></div>
          {{ $t('booking_status.waiting_for_check_in') }}
        </div>
        <div class="d-flex justify-space-between">
          <div class="dashboard-calendar-legend no-show"></div>
          {{ $t('booking_status.no_show') }}
        </div>
        <div class="d-flex justify-space-between">
          <div class="dashboard-calendar-legend created-by-admin"></div>
          {{ $t('booking_status.created_by_admin') }}
        </div>
        <div class="d-flex justify-space-between">
          <div class="dashboard-calendar-legend create-admin-booking"></div>
          {{ $t('booking_status.create_admin_booking') }}
        </div>
      </div>
    </div>

    <v-menu v-model="sessionMenuOpened"
            offset-x
            :close-on-content-click="false"
            :activator="selectedSessionTarget">
      <v-card outlined v-if="selectedSession && selectedSessionBooking">
        <v-card-title>{{ selectedSession.item.name }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field readonly
                            :label="$t('admin_acc_member.title')"
                            v-if="selectedSessionBooking && selectedSessionBooking.reference_number"
                            :value="selectedSessionBooking.hkiarace_account.surname + ', ' + selectedSessionBooking.hkiarace_account.given_name">
              </v-text-field>
              <v-text-field readonly
                            :label="$t('booking.facility')"
                            :value="selectedSessionBooking.item.name"></v-text-field>
              <v-text-field readonly
                            :label="$t('admin_acc_booking.date')"
                            :value="bookingDateLabel(selectedSessionBooking)"></v-text-field>
              <v-text-field readonly
                            :label="$t('admin_acc_booking.time')"
                            :value="bookingTimeLabel(selectedSessionBooking)"></v-text-field>
              <v-textarea readonly
                          :label="$t('admin_acc_facility_type.additional_items')"
                          v-if="selectedSessionBooking.additional_items.length > 0"
                          :rows="selectedSessionBooking.additional_items.length"
                          no-resize
                          :value="selectedSessionBooking.additional_items.map((i)=> `${i.type.name} x ${i.count}`).join('\n')"></v-textarea>
              <v-text-field readonly
                            :label="$t('admin_acc_booking.checkin_time')"
                            v-if="selectedSessionBooking.checkin_time"
                            :value="checkinTimeLabel(selectedSessionBooking)"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="#2bc7ca"
                 @click="showBookingDetails(selectedSessionBooking)">
            {{ $t('detail') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    <EditBookingModal :shown="sessionBookingModalShown"
                      :booking-id="selectedSessionBooking ? selectedSessionBooking.id : checkInBookingId"
                      @cancel="sessionBookingModalFinish"
                      @refresh-dashboard="refreshDashboard"></EditBookingModal>
  </v-container>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faChevronCircleLeft} from '@fortawesome/free-solid-svg-icons'
import {DateTime} from 'luxon'
import {computed, onMounted, ref, watch} from '@vue/composition-api';
import DateInput from "../../../components/DateInput";
import _ from 'lodash';
import $ from 'jquery';
import Vue from 'vue';
import GymPassCheckInButton from "@/components/acc_booking/GymPassCheckInButton";
import {BOOKING_STATUS} from "@/constants";
import EditBookingModal from "@/components/acc_booking/booking/EditBookingModal";
import GymCheckInModal from "@/components/acc_booking/dashboard/GymCheckInModal";
import JwtScanner from "@/components/acc_booking/JwtScanner";
import EditMemberModal from "@/components/member/EditMemberModal";
import CheckOutModal from "@/components/acc_booking/dashboard/CheckOutModal";
import WhiteCardActiveRecordModal from "@/components/acc_booking/white_card/WhiteCardActiveRecordModal";
import AdminFacilityCheckInModal from "@/components/acc_booking/AdminFacilityCheckInModal";
import AddBookingModal from "@/components/acc_booking/booking/AddBookingModal";

library.add(faChevronCircleLeft);

export default {
  name: 'AccBookingDashboard',
  components: {WhiteCardActiveRecordModal, CheckOutModal, EditMemberModal, GymCheckInModal, EditBookingModal, GymPassCheckInButton, DateInput},
  setup(props, {root, emit}) {
    const checkInModalShown = ref(false);
    const checkOutModalShown = ref(false);

    const checkInBookingId = ref(null);

    const editingMemberId = ref(null);
    const editMemberModalShown = ref(false);
    const onEditMemberModalFinish = function () {
      editingMemberId.value = null;
      editMemberModalShown.value = false;
    }

    const startFacilityCheckIn = async function () {
      const needRefresh = await root.$dialog.showAndWait(AdminFacilityCheckInModal, {
        showClose: false,
        persistent: true,
        width: '80vw',
      });

      if (needRefresh) {
        getSessions();
      }
    }
    const scanToCheckIn = async function () {
      const {bki, sub} = await root.$dialog.showAndWait(JwtScanner, {
        title: root.$t('admin_acc_booking.check_in_scan_title'),
        targetKey: ['bki', 'sub'],
      });

      if (bki) {
        checkInBookingId.value = bki;
        sessionBookingModalShown.value = true;
      } else if (sub) {
        editingMemberId.value = sub;
        editMemberModalShown.value = true;
      }
    }
    const checkingOutRecord = ref(null);
    const scanToCheckOut = async function () {
      let cardId = await root.$dialog.showAndWait(JwtScanner, {
        title: root.$t('admin_acc_white_card.scan_qr_code'),
        targetKey: 'wht',
        manualInputKey: 'wht',
        manualInputLabel: root.$t('admin_acc_white_card.id'),
      });

      if (cardId !== undefined) {
        let regex = /^A([0-9]*)$/;
        if (regex.test(cardId)) {
          cardId = parseInt(cardId.match(regex)[1])
        }

        root.$callAPI('aafb/admin/white_card/', {white_card_id: cardId}, (response) => {
          if (response.body.check_in_record) {
            checkingOutRecord.value = response.body.check_in_record;
            checkOutModalShown.value = true;
          } else {
            checkingOutRecord.value = null;
            root.$showAlertMessage(root.$t('admin_acc_white_card.not_check_in'));
          }
        })
      }
    };

    const dashboardDate = ref(root.$route.query.d ? DateTime.fromSeconds(parseInt(root.$route.query.d)).toISO() : DateTime.fromJSDate(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).toISO());
    const calendarDate = computed(() => {
      return DateTime.fromISO(dashboardDate.value).toISODate();
    })

    const regions = ref([]);
    const getRegions = function () {
      root.$callAPI('room/region/', {}, function (response) {
        regions.value = response.body.regions;
      });
    };
    const itemTypes = ref([]);
    const getItemTypes = function () {
      root.$callAPI('aafb/facility_types/', {}, function (response) {
        itemTypes.value = response.body.item_types;
      });
    };
    const selectedFilter = ref({
      regionId: root.$route.query.r || null,
      typeId: root.$route.query.t || null,
    });
    const filterOptions = computed(() => {
      return _.concat(
        [{value: {regionId: null, typeId: null}, text: root.$t('all')}],
        [{disabled: true, text: root.$t('admin_acc_facility_type.title')}],
        itemTypes.value.map(function (t) {
          return {value: {regionId: null, typeId: t.id}, text: t.name};
        }),
        [{disabled: true, text: root.$t('admin_acc_region.title')}],
        regions.value.map(function (r) {
          return {value: {regionId: r.id, typeId: null}, text: r.name};
        }),
      );
    })

    const items = ref([]);
    const itemMap = computed(() => {
      let map = {};
      items.value.forEach((i) => {
        map[i.id] = i;
      });
      return map;
    })
    const categories = computed(() => {
      return items.value.map((i) => i.id);
    });
    const bookings = ref([]);
    const bookingMap = computed(() => {
      let map = {};
      bookings.value.forEach((i) => {
        map[i.id] = i;
      });
      return map;
    })
    const sessions = ref([]);
    const processedSessions = computed(() => {
      let bookingMap = {}
      _.forEach(bookings.value, (b) => {
        bookingMap[b.id] = b;
      })

      let seenBookingIds = new Set();
      const processedSessions = sessions.value.map((s) => {
        if (s.booking && bookingMap[s.booking] && bookingMap[s.booking].item.id === s.item) {
          seenBookingIds.add(s.booking);
        }

        return {
          ...s,
          name: '',
          category: s.item,
          start: DateTime.fromISO(s.start).toFormat('yyyy-MM-dd HH:mm'),
          end: DateTime.fromISO(s.end).toFormat('yyyy-MM-dd HH:mm'),
        }
      });

      const dayStart = DateTime.fromISO(calendarDate.value).startOf('day');
      const dayEnd = DateTime.fromISO(calendarDate.value).endOf('day');

      // Generate Booking Events
      const processedBookings = [];
      _.forEach(bookings.value, (b) => {
        if (!seenBookingIds.has(b.id) && b.status !== BOOKING_STATUS.CANCELLED_BY_ADMIN) {
          // Handle Cross-Day Bookings
          let bookingStart = DateTime.fromISO(b.start_time);
          let bookingEnd = DateTime.fromISO(b.end_time);

          const start = bookingStart < dayStart ? dayStart : bookingStart;
          const end = bookingEnd > dayEnd ? dayEnd : bookingEnd;

          processedBookings.push({
            booking: b.id,
            name: '',
            item: b.item,
            category: b.item.id,
            start: start.toFormat('yyyy-MM-dd HH:mm'),
            end: end.toFormat('yyyy-MM-dd HH:mm'),
          });
        }
      })

      return _.concat((createdEvent.value ? [{
        ...createdEvent.value,
        start: DateTime.fromISO(createdEvent.value.start).toFormat('yyyy-MM-dd HH:mm'),
        end: DateTime.fromISO(createdEvent.value.end).toFormat('yyyy-MM-dd HH:mm'),
      }] : []), processedSessions, processedBookings);
    });
    const getSessionColor = function (s) {
      if (s.admin_booking) {
        return 'create-admin-booking';
      }

      if (s.status === 0) { // Available
        return 'available';
      } else if (s.status === 2) { // Excluded by other items
        // return '#e70c0c';
        return 'excluded';
      } else {
        if (s.booking) {
          let booking = bookingMap.value[s.booking];

          if (booking.status === BOOKING_STATUS.CONFIRMED) {
            return booking.checkin_time ? 'checked-in' : 'not-checked-in';
          } else {
            return {
              [BOOKING_STATUS.NO_SHOW]: 'no-show',
              [BOOKING_STATUS.CREATED_BY_ADMIN]: 'created-by-admin',
            }[booking.status];
          }
        }
      }

      return 'rgba(51,51,51,0.26)';
    };
    const firstInterval = computed(() => {
      let minStart = _.min(processedSessions.value.map((s) => {
        let start = DateTime.fromFormat(s.start, 'yyyy-MM-dd HH:mm');
        return (start.toSeconds() + start.offset * 60) % (24 * 3600);
      })) || 0;

      return Math.floor(minStart / 3600) - 1;
    });
    const intervalCount = computed(() => {
      let a = processedSessions.value.map((s) => {
        let start = DateTime.fromFormat(s.start, 'yyyy-MM-dd HH:mm');
        let end = DateTime.fromFormat(s.end, 'yyyy-MM-dd HH:mm');

        if (start.hasSame(end, 'day')) {
          return Math.ceil((end.toSeconds() + end.offset * 60) % (24 * 3600) / 3600);
        } else {
          return 24;
        }
      });

      return (_.max(a) || 24) - firstInterval.value + 1;
    });

    const sessionMenuOpened = ref(false);
    const selectedSession = ref(null);
    const selectedSessionTarget = ref(null);
    const selectedSessionBooking = computed(() => {
      if (selectedSession.value) {
        return bookingMap.value[selectedSession.value.booking];
      }
      return null;
    })

    const onSessionMouseDown = function ({event, nativeEvent}) {
      nativeEvent.stopPropagation();
    }
    const createBooking = async function (event) {
      const item = itemMap.value[event.category];
      const success = await root.$dialog.showAndWait(AddBookingModal, {
        showClose: false,
        persistent: true,
        width: '80vw',

        itemTypeId: item.type,
        itemId: item.id,
        startTime: DateTime.fromFormat(event.start, 'yyyy-MM-dd HH:mm').toISO(),
        endTime: DateTime.fromFormat(event.end, 'yyyy-MM-dd HH:mm').toISO(),
      })
      if (success) {
        cancelCreate();
        getSessions();
      }
    }
    const sessionClicked = function ({event, nativeEvent}) {
      const open = async () => {
        if (event.admin_booking) {
          return;
        }

        // Excluded slots are blocked by another item's booking (physical
        // exclusion or sport lock), not booked themselves -- no detail popup,
        // same as any other unavailable slot.
        if (event.status === 2) {
          return;
        }

        if (event.status !== 0) {
          selectedSession.value = event;
          selectedSessionTarget.value = nativeEvent.target;
          setTimeout(() => sessionMenuOpened.value = true, 10);
        } else if (!createdEvent.value || event.category !== createdEvent.value.category) {
          createdEvent.value = {
            name: `NEW ADMIN BOOKING`,
            start: DateTime.fromFormat(event.start, 'yyyy-MM-dd HH:mm').toISO(),
            end: DateTime.fromFormat(event.end, 'yyyy-MM-dd HH:mm').toISO(),
            timed: true,
            category: event.category,
            admin_booking: true,
          }
        }
      }

      if (sessionMenuOpened.value) {
        sessionMenuOpened.value = false;
        setTimeout(open, 10);
      } else {
        open();
      }
    };

    const toTime = function (tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
    }
    const roundTime = function (time, down = true) {
      const roundTo = 60; // minutes
      const roundDownTime = roundTo * 60 * 1000;

      const rounded = down
        ? time - time % roundDownTime
        : time + (roundDownTime - (time % roundDownTime))

      return DateTime.fromJSDate(new Date(rounded)).toISO();
    }
    const dragEvent = ref(null);
    const dragTime = ref(null);
    const createdEvent = ref(null);

    const cancelCreate = function () {
      dragEvent.value = null;
      dragTime.value = null;
      createdEvent.value = null;
    }
    const timeClicked = function (evt) {
      if (sessionMenuOpened.value) {
        return;
      }

      const mouseTime = toTime(evt);

      if (createdEvent.value === null || evt.category !== createdEvent.value.category) {
        const start = roundTime(mouseTime);
        const end = DateTime.fromISO(start).plus({'minutes': 60}).toISO();
        createdEvent.value = {
          name: `NEW ADMIN BOOKING`,
          start: start,
          end: end,
          timed: true,
          category: evt.category,
          admin_booking: true,
        }
        dragEvent.value = 'extend';
      }
    }
    const mouseMove = function (evt) {
      if (createdEvent.value && dragEvent.value) {
        if (dragEvent.value === 'extend') {
          const mouseTime = roundTime(toTime(evt), false);
          createdEvent.value = {
            ...createdEvent.value,
            end: mouseTime,
          }
        }

        if (dragEvent.value === 'drag') {
          const mouseTime = roundTime(toTime(evt));
          createdEvent.value = {
            ...createdEvent.value,
            start: mouseTime,
            end: DateTime.fromISO(mouseTime).plus({minutes: dragTime.value}).toISO(),
            category: evt.category,
          }
        }
      }
    }
    const startDrag = function (evt) {
      const start = DateTime.fromFormat(evt.start, 'yyyy-MM-dd HH:mm');
      const end = DateTime.fromFormat(evt.end, 'yyyy-MM-dd HH:mm');
      dragTime.value = end.diff(start, 'minutes').minutes;
      dragEvent.value = 'drag';
    }
    const extendBottom = function (evt) {
      dragEvent.value = 'extend';
    }
    const endDrag = function () {
      dragEvent.value = null;
      dragTime.value = null;
    }

    const referenceNumberLabel = function (booking) {
      return booking.reference_number ? "BV" + booking.reference_number.toString().padStart(10, '0') : root.$t('admin_acc_booking_add.maintenance_booking');
    };
    const bookingDateLabel = function (booking) {
      return DateTime.fromISO(booking.start_time).toFormat('yyyy-MM-dd');
    };
    const bookingTimeLabel = function (booking) {
      let startTime = DateTime.fromISO(booking.start_time);
      let endTime = DateTime.fromISO(booking.end_time);

      return startTime.toFormat('T') + ' - ' + endTime.toFormat('T');
    };
    const checkinTimeLabel = function (booking) {
      return DateTime.fromISO(booking.checkin_time).toFormat('yyyy-MM-dd HH:mm');
    };

    const sessionBookingModalShown = ref(false);
    const showBookingDetails = function (booking) {
      sessionBookingModalShown.value = true;
      // root.$router.push({name: 'acc-booking-booking-detail', params: {bookingId: booking.id}})
    };
    const sessionBookingModalFinish = function () {
      selectedSession.value = null;
      sessionBookingModalShown.value = false;
      // getSessions();
    }

    const refreshDashboard = function () {
      getSessions();
    }

    const getSessions = function () {
      // root.$callAPI('room/admin/session/', {
      root.$callAPI('aafb/admin/dashboard/', {
        start: dashboardDate.value,
        end: DateTime.fromISO(dashboardDate.value).plus({days: 1}).toISO(),
        type_id: selectedFilter.value.typeId,
        region_id: selectedFilter.value.regionId,
      }, function (response) {
        items.value = response.body.items;
        sessions.value = response.body.sessions;
        bookings.value = response.body.bookings;

        Vue.nextTick(() => {
          let headers = $('.v-calendar-category__columns');

          headers.scroll((e) => {
            headers.scrollLeft(e.target.scrollLeft);
          });
        });
      });
    };

    const updateRoute = function () {
      root.$router.replace({
        name: root.$route.name,
        params: root.$route.params,
        query: {
          d: dashboardDate.value ? DateTime.fromISO(dashboardDate.value).toSeconds() : null,
          r: selectedFilter.value.regionId,
          t: selectedFilter.value.typeId,
        },
      })
    };

    watch([dashboardDate, selectedFilter], () => {
      updateRoute();
      getSessions();
    }, {immediate: true});

    onMounted(() => {
      getRegions();
      getItemTypes();
    })

    return {
      checkInModalShown,
      checkOutModalShown,
      checkInBookingId,
      editingMemberId,
      editMemberModalShown,
      onEditMemberModalFinish,
      startFacilityCheckIn,
      scanToCheckIn,
      checkingOutRecord,
      scanToCheckOut,

      dashboardDate,
      calendarDate,
      filterOptions,
      selectedFilter,
      items,
      itemMap,
      categories,
      processedSessions,
      getSessionColor,
      firstInterval,
      intervalCount,

      sessionMenuOpened,
      selectedSession,
      selectedSessionTarget,
      selectedSessionBooking,
      onSessionMouseDown,
      createBooking,
      sessionClicked,

      createdEvent,
      cancelCreate,
      timeClicked,
      mouseMove,
      startDrag,
      endDrag,
      extendBottom,

      referenceNumberLabel,
      bookingDateLabel,
      bookingTimeLabel,
      checkinTimeLabel,
      sessionBookingModalShown,
      showBookingDetails,
      sessionBookingModalFinish,
      refreshDashboard,

      updateRoute,

      fromISO: DateTime.fromISO,
    }
  },
}
</script>

<style lang="less">
.admin-dashboard {
  font-size: 0.7rem;

  display: flex;
  flex-direction: column;

  .dashboard-calendar-legends {
    flex: 0 0 auto;
    padding: 8px;

    .dashboard-calendar-legend {
      width: 20px;
      height: 20px;
      margin-right: 8px;
      margin-bottom: 12px;
    }
  }

  .admin-dashboard-calendar {
    flex: 1 1 0;

    .create-event {
      height: 100%;
      cursor: move;

      .create-event-cancel {
        text-align: left;
        position: absolute;
        top: 0;
        left: 0;
        width: 15px;
      }

      .create-event-drag-top {
        text-align: center;
        position: absolute;
        top: 0;
        right: 0;
        width: 15px;
        cursor: move;
      }

      .create-event-drag-bottom {
        text-align: center;
        position: absolute;
        bottom: 0;
        left: calc(50% - 10px);
        width: 20px;
        cursor: ns-resize;
      }
    }
  }

  .v-calendar .v-event-timed-container {
    margin-right: 0 !important;
  }

  .v-calendar-daily_head-weekday, .v-calendar-daily_head-day-label {
    display: none;
  }

  .v-calendar-category .v-calendar-category__columns {
    overflow-x: auto;

    .v-calendar-category__column {
      min-width: 80px;
    }
  }

  .v-calendar-daily_head-day .v-calendar-category__columns .v-calendar-category__column-header {
    min-width: 80px;
  }

  .available {
    background: rgba(51, 51, 51, 0.26);
  }

  .excluded {
    background: rgba(231, 12, 12, 0.5);
  }

  .checked-in {
    background: rgba(0, 255, 34, 0.8);
  }

  .not-checked-in {
    background: repeating-linear-gradient(45deg, rgba(51, 51, 51, 0.26) 0, rgba(51, 51, 51, 0.26) 10px, rgba(0, 255, 34, 0.8) 10px, rgba(0, 255, 34, 0.8) 20px) !important;
  }

  .no-show {
    background: repeating-linear-gradient(45deg, rgba(231, 12, 12, 0.8) 0, rgba(231, 12, 12, 0.8) 10px, rgba(0, 255, 34, 0.8) 10px, rgba(0, 255, 34, 0.8) 20px) !important;
  }

  .created-by-admin {
    background: repeating-linear-gradient(45deg, rgb(231, 184, 12, 0.8) 0, rgba(231, 184, 12, 0.8) 10px, rgba(0, 0, 0, 0.8) 10px, rgba(0, 0, 0, 0.8) 20px) !important;
  }

  .create-admin-booking {
    background: rgba(0, 81, 255, 0.8) !important;
    left: 0 !important;
    width: 100% !important;

    &.dashboard-calendar-legend {
      width: 20px !important;
    }

    &:not(.dashboard-calendar-legend) {
      z-index: 10;
    }
  }
}
</style>
